import { useEffect, useState } from "react";

/**
 * Keeps the input responsive while the work it drives runs at a slower rate:
 * the text field updates on every keystroke, the 50k-row scan behind it does
 * not.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
